import { ChevronDownIcon } from "../icons";
import { cn } from "../utils/class-names";

interface FlippingChevronProps {
  isOpen: boolean;
  className?: string;
}

export function FlippingChevron({
  isOpen,
  className,
}: FlippingChevronProps): JSX.Element {
  return (
    <ChevronDownIcon
      className={cn(
        "transition-transform duration-150 ease-in [transform-style:preserve-3d]",
        isOpen ? "[transform:rotateX(180deg)]" : "",
        className
      )}
    />
  );
}
